export interface AgentTransferLog {
  id: string;
  agentId: string;
  companyId: string;
  transferredBy: string;
  adsTransferredCount: number;
  creditsTransferred: number;
  agentCreditsBefore: number;
  agentCreditsAfter: number;
  companyCreditsBefore: number | null;
  companyCreditsAfter: number | null;
  reason: string | null;
  transferredAt: string;
  agent?: {
    id: string;
    name: string;
    email: string;
  };
  transferredByUser?: {
    id: string;
    name: string;
  };
}

export interface FindAgentTransferLogs {
  search?: string;
  limit?: number;
  skip?: number;
}

interface InitialState {
  data: AgentTransferLog[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};

